<template>
  <div>
    <!-- 底部 -->
    <div id="footer">
      <div class="con">
        <img src="/static/images/footer_bg.png" alt="">
        <div class="con-con">
          <div class="main-container g-flex flex-betn">
            <div class="left ">
              <h3>中国木偶艺术剧院</h3>
              <div class="clearfix">
                <p class="group f-left ">地址：北京市朝阳区安华西里甲一号（北三环安贞桥西）</p>
                <p class="group f-left">剧 院 业 务：010-64254847 / 64247084/ 64247085 </p>
                <p class="group f-left">团体票/团购预约：010-64254847 / 64247084/ 64247085 </p>
                <p class="group f-left">微信订票：010-64291675 </p>
                <p class="group f-left">全国赴外演出：13621109508</p>
                <p class="group f-left">电影咨询：010-64248998 </p>
              </div>

            </div>
            <div class="right">
              <ul class="list clearfix">
                <li class="f-left">
                  <div class="title" @click="router('overview')"><span>剧院概览</span></div>
                  <ul class="li-list">
                    <li>剧院介绍</li>
                    <li>院长介绍</li>
                    <li>机构设置</li>
                    <li>企业文化</li>
                    <li>群星璀璨</li>
                  </ul>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('center')"><span>演出中心</span></div>
                  <ul class="li-list">
                    <li>大剧场</li>
                    <li>小铃铛体验剧场</li>
                    <li>黑猫小D生活剧场</li>
                  </ul>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('cloudTheater')"><span>5G剧场</span></div>
                  <ul class="li-list">
                    <li>精品剧目</li>
                    <li>小视屏</li>
                    <li>在线直播</li>
                  </ul>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('cooperation')"><span>商务合作</span></div>
                  <ul class="li-list">
                    <li>品牌加盟</li>
                    <li>剧场出租</li>
                  </ul>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('education')"><span>艺术教育</span></div>
                  <ul class="li-list">
                    <li>在线培训</li>
                    <li>小太阳艺术团</li>
                  </ul>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('news')"><span>新闻动态</span></div>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('goods')"><span>文创产品</span></div>
                </li>
                <li class="f-left">
                  <div class="title" @click="router('center')"><span>在线购票</span></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright">
        Copyright © 2016 LA Company. All Rights Resrved. &nbsp; &nbsp; &nbsp; &nbsp; <a style="color: #999;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备08003619号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {
    router(page) {
      this.$router.push('/' + page)
    }
  }
}
</script>

<style lang='scss' scoped>
/* footer */

#footer {
  width: 100%;
}

#footer .con {
  height: 306px;
  color: #fff;
}
#footer {
  .con {
    position: relative;
    .con-con {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
#footer .con .right .list > li > div {
  font-size: 16px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
}

#footer .con .right .list > li > div span {
  position: relative;
}

#footer .con .right .list > li > div span::after {
  content: '';
  position: absolute;
  left: -10px;
  top: 50%;
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background-color: #fff;
}

#footer .con .right .list > li .li-list li {
  font-size: 14px;
  text-align: center;
}
#footer .con .main-container {
  height: 100%;
  padding: 30px 0;
}

#footer .con .left {
  width: 704px;
  height: 100%;
}

#footer .con .left > h3 {
  font-size: 32px;
  margin-bottom: 30px;
}

#footer .con .left .group {
  margin-top: 10px;
  font-size: 16px;
  line-height: 32px;
}

#footer .con .left .group:nth-child(3),
#footer .con .left .group:nth-child(5) {
  width: 490px;
}

#footer .con .right {
  width: 495px;
  height: 100%;
  border-left: 1px dashed #999;
}

#footer .con .right div {
  display: block;
}

#footer .con .right .list > li {
  width: 25%;
  line-height: 2;
}

#footer .copyright {
  height: 64px;
  width: 100%;
  background-color: #fff;
  color: #999;
  font-size: 14px;
  line-height: 64px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/footer/index.vue